/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    VccCredentialsCreateRequest,
    VccCredentialsCreateRequestFromJSON,
    VccCredentialsCreateRequestToJSON,
    VccCredentialsCreateRequestValidationData,
    VccCredentialsCreateRequestValidationDataFromJSON,
    VccCredentialsCreateRequestValidationDataToJSON,
    VccCredentialsFormConfiguration,
    VccCredentialsFormConfigurationFromJSON,
    VccCredentialsFormConfigurationToJSON,
    VccCredentialsFormData,
    VccCredentialsFormDataFromJSON,
    VccCredentialsFormDataToJSON,
    VccCredentialsUpdateRequest,
    VccCredentialsUpdateRequestFromJSON,
    VccCredentialsUpdateRequestToJSON,
    VccCredentialsUpdateRequestValidationData,
    VccCredentialsUpdateRequestValidationDataFromJSON,
    VccCredentialsUpdateRequestValidationDataToJSON,
} from '../models';

export interface ApiVccCredentialsFormCreatePostRequest {
    vccCredentialsCreateRequest?: VccCredentialsCreateRequest;
}

export interface ApiVccCredentialsFormGetByIdGetRequest {
    id?: string;
}

export interface ApiVccCredentialsFormUpdatePostRequest {
    vccCredentialsUpdateRequest?: VccCredentialsUpdateRequest;
}

export interface ApiVccCredentialsFormValidateCreatePostRequest {
    vccCredentialsCreateRequest?: VccCredentialsCreateRequest;
}

export interface ApiVccCredentialsFormValidateUpdatePostRequest {
    vccCredentialsUpdateRequest?: VccCredentialsUpdateRequest;
}

/**
 * no description
 */
export class VccCredentialsFormApi extends runtime.BaseAPI {

    /**
     */
    async apiVccCredentialsFormConfigurationGetRaw(): Promise<runtime.ApiResponse<VccCredentialsFormConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/VccCredentialsForm/Configuration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => VccCredentialsFormConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiVccCredentialsFormConfigurationGet(): Promise<VccCredentialsFormConfiguration> {
        const response = await this.apiVccCredentialsFormConfigurationGetRaw();
        return await response.value();
    }

    /**
     */
    async apiVccCredentialsFormCreatePostRaw(requestParameters: ApiVccCredentialsFormCreatePostRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/VccCredentialsForm/Create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VccCredentialsCreateRequestToJSON(requestParameters.vccCredentialsCreateRequest),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiVccCredentialsFormCreatePost(requestParameters: ApiVccCredentialsFormCreatePostRequest): Promise<void> {
        await this.apiVccCredentialsFormCreatePostRaw(requestParameters);
    }

    /**
     */
    async apiVccCredentialsFormGetByIdGetRaw(requestParameters: ApiVccCredentialsFormGetByIdGetRequest): Promise<runtime.ApiResponse<VccCredentialsFormData>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/VccCredentialsForm/GetById`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => VccCredentialsFormDataFromJSON(jsonValue));
    }

    /**
     */
    async apiVccCredentialsFormGetByIdGet(requestParameters: ApiVccCredentialsFormGetByIdGetRequest): Promise<VccCredentialsFormData> {
        const response = await this.apiVccCredentialsFormGetByIdGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiVccCredentialsFormUpdatePostRaw(requestParameters: ApiVccCredentialsFormUpdatePostRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/VccCredentialsForm/Update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VccCredentialsUpdateRequestToJSON(requestParameters.vccCredentialsUpdateRequest),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiVccCredentialsFormUpdatePost(requestParameters: ApiVccCredentialsFormUpdatePostRequest): Promise<void> {
        await this.apiVccCredentialsFormUpdatePostRaw(requestParameters);
    }

    /**
     */
    async apiVccCredentialsFormValidateCreatePostRaw(requestParameters: ApiVccCredentialsFormValidateCreatePostRequest): Promise<runtime.ApiResponse<VccCredentialsCreateRequestValidationData>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/VccCredentialsForm/ValidateCreate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VccCredentialsCreateRequestToJSON(requestParameters.vccCredentialsCreateRequest),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => VccCredentialsCreateRequestValidationDataFromJSON(jsonValue));
    }

    /**
     */
    async apiVccCredentialsFormValidateCreatePost(requestParameters: ApiVccCredentialsFormValidateCreatePostRequest): Promise<VccCredentialsCreateRequestValidationData> {
        const response = await this.apiVccCredentialsFormValidateCreatePostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiVccCredentialsFormValidateUpdatePostRaw(requestParameters: ApiVccCredentialsFormValidateUpdatePostRequest): Promise<runtime.ApiResponse<VccCredentialsUpdateRequestValidationData>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/VccCredentialsForm/ValidateUpdate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VccCredentialsUpdateRequestToJSON(requestParameters.vccCredentialsUpdateRequest),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => VccCredentialsUpdateRequestValidationDataFromJSON(jsonValue));
    }

    /**
     */
    async apiVccCredentialsFormValidateUpdatePost(requestParameters: ApiVccCredentialsFormValidateUpdatePostRequest): Promise<VccCredentialsUpdateRequestValidationData> {
        const response = await this.apiVccCredentialsFormValidateUpdatePostRaw(requestParameters);
        return await response.value();
    }

}
